import { createUrl } from '../shared/UrlUtils/urlUtils'

const AppRouteNames = {
	home: '/',
	course: '/course/:courseSlug',
	topic: '/course/:courseSlug/topic/:topicSlug',
	// If your on localhost then it tries to feed in localhost/redirect, this will fail in prod as its insecure and needs to be enabled on our API.
	logout: createUrl(import.meta.env.VITE_SECDIM_ID_FRONTEND, {
		path: ['account', 'logout'],
	}),
	settingsID: createUrl(import.meta.env.VITE_SECDIM_ID_FRONTEND, {
		path: ['account', 'settings'],
	}), // send them to settings where they can do it.
}

export default AppRouteNames
